import {Endpoint} from '@eryxcoop/appyx-comm';

export default class AddArticlesToOrderEndpoint extends Endpoint {

  adaptValues({orderNumber, articles}) {
    return {
      'order_number': orderNumber,
      'articles': this.adaptArticles(articles),
    }
  }

  adaptArticles(articles) {
    return articles.map((article) => {
          return {
            code: article.code,
            amount: article.amount,
          }
        }
      )
  }

}